import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import ActivityItem from "./item";

const Activities = ({ activities, hasMore, onLoadMore }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTACT);

  return (
    <div className="activities__log">
      {activities.map((activity, index) => (
        <ActivityItem
          key={activity.callData?.id || activity.date || index}
          activity={activity}
        />
      ))}
      {hasMore && (
        <button
          className="activities__log--load-more"
          onClick={onLoadMore}
        >
          {t("ACTIVITIES.LOAD_MORE")}
        </button>
      )}
    </div>
  );
};

export default Activities;
